module.exports = __webpack_public_path__ + "img/Argon Dashboard PRO@2x.9a31712b.png";